var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu-wrapper"},[_c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav"},_vm._l((_vm.menus),function(item,index){return _c('div',{key:index,class:{'active' :Number(_vm.activeIndex) === index },on:{"click":function($event){return _vm.jump(item, index)}}},[_vm._v(_vm._s(item.title))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }